/** Great-circle distance (km) between two WGS-84 lat/lng points. */
export function haversineKm(lat1, lng1, lat2, lng2) {
    if (
        typeof lat1 !== "number" || typeof lng1 !== "number" ||
        typeof lat2 !== "number" || typeof lng2 !== "number"
    ) return null;
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
}

export function formatDistance(km) {
    if (km == null) return null;
    if (km < 1) return `${Math.round(km * 1000)} m`;
    if (km < 10) return `${km.toFixed(1)} km`;
    return `${Math.round(km)} km`;
}
